<template>
    <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-btn flat slot="activator"><v-icon left>notification_important</v-icon>Notifications</v-btn>
        <v-card>
            <form v-on:submit.prevent="create">
                <v-card-title>
                    <span class="headline">Notifications:</span>
                </v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-data-table
                                v-if="notifications"
                                :items="notifications"
                                class="elevation-1"
                                hide-actions
                                :headers="headers"
                        >
                            <template slot="items" slot-scope="props">
                                <td>{{ props.item.name }}</td>
                                <td><v-checkbox v-model="data.notifications" :value="props.item.id"></v-checkbox></td>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { DICCIONARIO } from '../../../../diccionario';

    export default {
        props: ['id', 'contact'],
        data: () => ({
            dialog: false,
            data : {},
            notifications: null,
            headers: [
                {
                    text: 'Notification',
                    sortable: false,
                    value: 'name'
                },
                { text: 'Send', value: 'calories', sortable: false, },
            ],
        }),
        created () {

        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        watch: {
            dialog: function(dialog) {
                if (dialog == true) {
                    this.data = Object.assign({}, this.contact);
                    this.getNotifications();
                }
            }
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$emit('guardar', this.data);
                        this.dialog = false;
                    }
                });
            },
            cancel () {
                this.dialog = false;
            },
            getNotifications() {
                var params = {
                    filters : {
                        configurable: 1,
                        ftn: 1
                    },
                };
                this.$store.dispatch('getNotifications', params).then((res) => {
                    var notifications = this.contact.notifications;
                    this.notifications = res.data.data;
                    this.data.notifications = [];
                    for (var i = 0; i < notifications.length; i++) {
                        this.data.notifications.push(notifications[i].id);
                    }
                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/components/NotificationsComponent.vue